import { render } from "./TreeItem.vue?vue&type=template&id=5d7fa087"
import script from "./TreeItem.vue?vue&type=script&lang=js"
export * from "./TreeItem.vue?vue&type=script&lang=js"

import "./TreeItem.vue?vue&type=style&index=0&id=5d7fa087&lang=scss"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__